module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "page-title"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('ul', {
    staticClass: "nav"
  }, [_c('li', {
    staticClass: "nav-item border-left-0"
  }, [_c('a', {
    staticClass: "nav-link",
    on: {
      "click": function($event) {
        _vm.goHome()
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/image/icon/home.png"),
      "height": "40"
    }
  })])]), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": {
        name: 'works.list'
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('assignment')))])], 1), _vm._v(" "), (_vm.workObj) ? _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link"
  }, [_vm._v(_vm._s(_vm.workObj.name))])]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "container mt-3 pt-5 pb-5",
    class: {
      'bg-white': true
    },
    staticStyle: {
      "min-height": "60vh"
    }
  }, [(_vm.isEmpty) ? [_c('empty-page', {
    attrs: {
      "title": _vm.$t('no_coursework_assigned'),
      "description": _vm.$t('no_assigned_courses')
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "row mt-5 d-flex"
  }, [_c('button', {
    staticClass: "btn btn-success btn-block mt-5 mb-5 w-50 mx-auto",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        _vm.$router.push('/')
      }
    }
  }, [_vm._v("我知道了")])])] : _c('div', {
    staticClass: "row"
  }, [(!_vm.workObj) ? _c('div', {
    staticClass: "col-sm-6 offset-sm-3"
  }, [_c('ul', {
    staticClass: "list-group"
  }, _vm._l((_vm.courses.list), function(course, index) {
    return _c('li', {
      key: index + course.id,
      staticClass: "list-group-item d-flex justify-content-between rounded p-0 mb-3"
    }, [_c('div', {
      staticClass: "text-left p-1 pl-3 mr-auto"
    }, [_vm._v("\n              " + _vm._s(_vm.$t('course_content')) + "："), _c('span', {
      staticStyle: {
        "font-weight": "bold"
      }
    }, [_vm._v(_vm._s(course.name))]), _c('br'), _vm._v("\n              " + _vm._s(_vm.$t('assigned_time')) + "：" + _vm._s(course.createTime)), _c('br'), _vm._v("\n              " + _vm._s(_vm.$t('assign_class')) + "：" + _vm._s(course.groupName)), _c('br'), _vm._v("\n              " + _vm._s(_vm.$t('assigned_by')) + "：" + _vm._s(course.teacherName)), _c('br'), _vm._v("\n              " + _vm._s(_vm.$t('number_of_courses')) + "：" + _vm._s(course.lessonCount) + "\n            ")]), _vm._v(" "), _c('div', {
      staticClass: "d-flex align-items-center pr-3"
    }, [(course.isDone) ? _c('img', {
      attrs: {
        "src": require("../assets/image/icon/check_on.png")
      }
    }) : _c('img', {
      attrs: {
        "src": require("../assets/image/icon/check_off.png")
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "d-flex align-items-center rounded list-group-item-playbtn",
      staticStyle: {
        "background-color": "#ffb12d"
      }
    }, [_c('span', {
      staticClass: "w-100 text-center",
      on: {
        "click": function($event) {
          _vm.openWork(course)
        }
      }
    }, [_c('img', {
      attrs: {
        "src": require("../assets/image/icon/video_play.png")
      }
    })])])])
  }), 0), _vm._v(" "), _c('pagination', {
    staticClass: "mt-3",
    attrs: {
      "current": _vm.courses.pageIndex,
      "total": _vm.courses.pageCount
    },
    on: {
      "page": _vm.updatePage
    }
  })], 1) : _c('div', {
    staticClass: "col-sm-12"
  }, [_c('ul', {
    staticClass: "nav nav-tabs mb-3"
  }, [_c('li', {
    staticClass: "nav-item ml-5"
  }, [_c('a', {
    staticClass: "nav-link rounded-top",
    class: {
      'active': _vm.tab === 'lesson'
    },
    on: {
      "click": function($event) {
        _vm.tab = 'lesson'
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('course_list')))])]), _vm._v(" "), _c('li', {
    staticClass: "nav-item ml-3"
  }, [_c('a', {
    staticClass: "nav-link rounded-top",
    class: {
      'active': _vm.tab === 'attachment'
    },
    on: {
      "click": function($event) {
        _vm.tab = 'attachment'
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('attachment_file')))])])]), _vm._v(" "), (_vm.tab === 'lesson') ? _c('div', {
    staticClass: "ml-5 mr-5"
  }, [_c('ul', {
    staticClass: "list-group"
  }, _vm._l((_vm.courseLessons.list), function(course, index) {
    return _c('li', {
      key: course.id,
      staticClass: "list-group-item d-flex justify-content-between mb-3 border-top-0 border-left-0 border-right-0"
    }, [_c('div', {
      staticClass: "d-flex align-items-center mr-auto"
    }, [_c('b', [_vm._v(_vm._s(index < 9 ? '0' + (index + 1) : (index + 1)) + ". " + _vm._s(course.localName))]), _vm._v(" " + _vm._s(course.name) + "\n              ")]), _vm._v(" "), _vm._m(0, true), _vm._v(" "), _c('div', {
      staticClass: "d-flex align-items-center mr-3"
    }, [_c('icon-button', {
      attrs: {
        "name": "more_info",
        "alt": _vm.$t('start_the_course')
      },
      nativeOn: {
        "click": function($event) {
          _vm.$router.push({
            name: 'lesson.player',
            params: {
              lessonId: course.id
            }
          })
        }
      }
    })], 1)])
  }), 0), _vm._v(" "), _c('pagination', {
    staticClass: "col-sm-12 mt-3",
    attrs: {
      "current": _vm.courseLessons.pageIndex,
      "total": _vm.courseLessons.pageCount
    },
    on: {
      "page": _vm.updatePage
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.tab === 'attachment') ? _c('div', {
    staticClass: "ml-5 mr-5"
  }, [_c('ul', {
    staticClass: "list-group"
  }, _vm._l((_vm.courseLessons.attachment.list), function(item, index) {
    return _c('li', {
      key: item.id,
      staticClass: "list-group-item d-flex justify-content-between mb-3 border-top-0 border-left-0 border-right-0"
    }, [_c('div', {
      staticClass: "d-flex align-items-center mr-3 text-left"
    }, [_vm._v("\n                " + _vm._s(item.name)), _c('br'), _vm._v("\n                " + _vm._s(Math.round(item.fileSize * 1000 / 1024 / 1024) / 1000) + " MB\n              ")]), _vm._v(" "), _c('div', {
      staticClass: "d-flex align-items-center mr-3"
    }, [_c('icon-button', {
      attrs: {
        "name": "student_download",
        "alt": _vm.$t('_download')
      },
      nativeOn: {
        "click": function($event) {
          _vm.getAttachment(item.id)
        }
      }
    })], 1)])
  }), 0)]) : _vm._e()])])], 2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "d-flex align-items-center mr-3"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/image/icon/check_off.png")
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-7358ccf2!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Works.vue
// module id = 739
// module chunks = 1